import './WhereToBuyButton.scss'

import { AppProviderContext } from '@websrc/App/AppContext'
import { Button, ButtonProps } from '@websrc/App/Components/Button/Button'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { matomo } from '@websrc/App/Tracking/Matomo'
import React, { useContext, useEffect } from 'react'

type WhereToBuyButtonProps = Omit<
  ButtonProps,
  'download' | 'target' | 'rel' | 'text' | 'href' | 'fontSize'
> & { assetId: number | string; productNumber: string }

export const WhereToBuyButton: React.FC<WhereToBuyButtonProps> = ({
  onClick,
  type,
  size,
  color,
  colorMode,
  iconPosition,
  disabled,
  width,
  isLoading,
  iconName,
  id,
  dataTestid,
  assetId,
  productNumber,
  reference,
  removePadding,
}) => {
  const src = 'https://cdn.channelsight.com/widget/scripts/cswidget.loader.js'
  const t = useStaticText()
  const { pageType, matomoPageTemplate, locale } = useContext(AppProviderContext)

  useEffect(() => {
    // Hide ""Find a Distributor"" button on product detail page when ChannelSight widget is present
    if (pageType.includes('product-details') || pageType.includes('product_detail')) {
      Array.from(document.querySelectorAll('li [data-text="Find a Distributor"]')).forEach((el) => {
        el.parentElement?.remove()
      })
    }
  }, [pageType])

  useEffect(() => {
    //scripts have to be removed and added again to make ChannelSight widget work in SPA
    document.getElementById('cswidgetloaderjs')?.remove()
    document.getElementById('cswidgetjs')?.remove()

    if (!document.getElementById('cswidgetloaderjs')) {
      const script = document.createElement('script')
      script.src = src
      script.id = 'cswidgetloaderjs'
      document.head.appendChild(script)
    }
  }, [])

  return (
    <Button
      aria-label={t.ecom.where_to_buy}
      channelSightAssetId={assetId}
      channelSightClassName={'cswidget'}
      channelSightProductSku={productNumber} // we use product number as sku
      color={color || 'black'}
      colorMode={colorMode || 'light'}
      dataTestid={dataTestid}
      disabled={disabled}
      iconName={iconName}
      iconPosition={iconPosition}
      id={id}
      isLoading={isLoading}
      onClick={(e) => {
        e.preventDefault()
        matomo.trackEvent(
          'engagement',
          matomoPageTemplate,
          [''],
          [
            'Where To Buy button (shows popup)',
            `Product number: ${productNumber}`,
            `ChannelSight asset id: ${assetId}`,
            `Locale: ${locale}`,
          ],
          'button'
        )
        onClick && onClick(e)
      }}
      reference={reference as React.MutableRefObject<HTMLButtonElement | null> | undefined}
      removePadding={removePadding}
      size={size || 'medium'}
      text={t.ecom.where_to_buy || 'Buy at reseller'}
      type={type || 'primary'}
      width={width}
    />
  )
}
